"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamAvailableCurrencies = void 0;
exports.streamAvailableCurrencies = [
    {
        code: 'usd',
        label: 'U.S. Dollar',
        stripeMinAmount: 0.5,
    },
    {
        code: 'eur',
        label: 'Euro',
        stripeMinAmount: 0.5,
    },
    {
        code: 'chf',
        label: 'Swiss franc',
        stripeMinAmount: 0.5,
    },
    {
        code: 'huf',
        label: 'Hungarian Forint',
        stripeMinAmount: 175,
    },
    {
        code: 'czk',
        label: 'Czech koruna',
        stripeMinAmount: 15,
    },
    {
        code: 'pln',
        label: 'Polish zloty',
        stripeMinAmount: 2,
    },
];
//# sourceMappingURL=consts.js.map